"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeroLinks = void 0;
exports.hasHeroLinks = hasHeroLinks;
var config_1 = require("../config");
var get_closest_1 = require("../helper/get-closest");
var HeroLinks = /*#__PURE__*/function () {
  function HeroLinks() {
    var _this = this;
    _classCallCheck(this, HeroLinks);
    this.heroLinksWrapper = null;
    this.toggleHeroLinksButton = null;
    this.href = null;
    this.toggleHeroLinksButton = document.querySelector(config_1.CONFIG.heroLinks.toggleButton);
    this.heroLinksWrapper = document.querySelector(config_1.CONFIG.heroLinks.main);
    this.heroLinkButtons = document.querySelectorAll(config_1.CONFIG.heroLinks.toggleHeroLinkButton);
    this.toggleHeroLinksButton.addEventListener('click', this.toggleHeroLinks.bind(this));
    if (this.heroLinkButtons.length > 0) {
      [].forEach.call(this.heroLinkButtons, function (button) {
        button.addEventListener('click', _this.toggleHeroLink.bind(_this));
      });
    }
  }
  return _createClass(HeroLinks, [{
    key: "toggleHeroLinks",
    value: function toggleHeroLinks(event) {
      event.preventDefault();
      if (this.heroLinksWrapper.classList.contains(config_1.CONFIG.heroLinks.activeClass)) {
        this.heroLinksWrapper.classList.remove(config_1.CONFIG.heroLinks.activeClass);
      } else {
        this.heroLinksWrapper.classList.add(config_1.CONFIG.heroLinks.activeClass);
      }
    }
  }, {
    key: "toggleHeroLink",
    value: function toggleHeroLink(event) {
      event.preventDefault();
      var button = (0, get_closest_1.getClosest)(config_1.CONFIG.heroLinks.toggleHeroLinkButton, event.target);
      if (this.heroLinksWrapper.classList.contains(config_1.CONFIG.heroLinks.activeClass)) {
        this.heroLinksWrapper.classList.remove(config_1.CONFIG.heroLinks.activeClass);
      }
      window.location.href = button.getAttribute('href');
    }
  }]);
}();
exports.HeroLinks = HeroLinks;
function hasHeroLinks() {
  if (document.querySelector(config_1.CONFIG.heroLinks.main)) {
    return true;
  }
  return false;
}